import { render, staticRenderFns } from "./MoResetPasswordPage.vue?vue&type=template&id=6a66cf04&scoped=true&"
import script from "./MoResetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./MoResetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./MoResetPasswordPage.vue?vue&type=style&index=0&id=6a66cf04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66cf04",
  null
  
)

export default component.exports